var render = function render(){var _vm=this,_c=_vm._self._c;return _c('order-details',[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"page_title"},[_vm._v("\n      確認送出報名表？\n    ")])]),_vm._v(" "),_c('div',{staticClass:"col-12 mb-5"},[_c('h5',[_vm._v("親愛的廠商您好：")]),_vm._v("\n    請仔細查看是否都已確認每一項報名活動，送出此報名表後將不再回到此活動報名流程，如果之後想要更改報名內容請至 企業專區做修改，謝謝！\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }